import { useGroupResponsibleDependencies } from '@/scopes/account/group-responsible/pages/dependencies';
import { identity } from 'ramda';
import { useStore } from 'zustand';
import * as React from 'react';
import { useSearchParams } from 'next/navigation';
import type { GroupResponsibleStore, GroupResponsibleTabName } from '@/scopes/account/group-responsible/domain/types';

export function useSetActiveTab() {
  const searchParams = useSearchParams();
  const { groupResponsibleStore } = useGroupResponsibleDependencies();
  const store = useStore(groupResponsibleStore, identity<GroupResponsibleStore>);

  const getActiveTab = React.useCallback((): GroupResponsibleTabName => {
    const tab = searchParams.get('activeTab');
    const validTabs: GroupResponsibleTabName[] = ['booking', 'participants', 'rooms', 'bus'];
    return validTabs.includes(tab as GroupResponsibleTabName) ? (tab as GroupResponsibleTabName) : 'participants';
  }, [searchParams]);

  React.useEffect(() => {
    store.changeTab(getActiveTab());
  }, [getActiveTab]);
}
